import styled from 'styled-components'

export const RadioText = styled.p`
	margin-left: 16px;
`
